export const sourceConstants = {
    /**
     * Sources status constants :
     */
    SOURCE_DEACTIVATE: 'READY',
    SOURCE_ACTIVATE: 'PUBLISHED',
    SOURCE_NEW: 'NEW',

    /**
     * Sources Parameters Constant types :
     * This should correspond to the value server is expecting
     */
    SOURCE_TITLE: "title",
    SOURCE_DESC: "description",
    SOURCE_DESC_LONG: "longDescription",

    /**
     * Source status constants for getSource responses :
     */
    SOURCE_STATUS_NEW: 'NEW',
    SOURCE_STATUS_PENDING: 'PENDING',
    SOURCE_STATUS_READY: 'READY',
    SOURCE_STATUS_PUBLISHED: 'PUBLISHED',
    SOURCE_STATUS_FAILED: 'FAILED',

    /**
     * Source validation failure details types :
     */
    SOURCE_VALIDATE_FAIL : {
        GOOGLE_DRIVE_QUOTA_EXCEEDED: 'GOOGLE_DRIVE_QUOTA_EXCEEDED',
        GOOGLE_DRIVE_VIRUS_SCAN_LARGE: 'GOOGLE_DRIVE_VIRUS_SCAN_LARGE',
        UNKNOWN: 'UNKNOWN',
        ZOOM_ACCESS_PROTECTED: 'ZOOM_ACCESS_PROTECTED',
    },

    /**
     * Source feature failure reasons:
     */
    SOURCE_FEATURE_FAILURE : {
        INSUFFICIENT_ORDER_GIST: 'INSUFFICIENT_ORDER_GIST',
        SUBSCRIPTION_UPGRADE_NEEDED: 'SUBSCRIPTION_UPGRADE_NEEDED',
    },

    /**
     * Source state based on status, usage in UX : media portfolio
     */
    SOURCE_STATE : {
        ACTIVE: 'active',
        DEACTIVATED: 'deactivated',
        PENDING: 'pending'
    },

    /**
     * Source Media identifiers : for instance, HOME refers to source for the home page
     */
    SOURCE_DEFAULT : {
        HOME: 'HOME',
        LEGAL: 'LEGAL',
        ZOOM: 'ZOOM',
        DEBATE_20_09_29: 'DEBATE_20_09_29',
        DEBATE_20_10_07: 'DEBATE_20_10_07'
    }

};